let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9WvZw")).then(() => parcelRequire('b9zHn'));